import type { TemplateChartSeries } from '@/types/charts';

export function getShortTitle(
  templateChartSeries: TemplateChartSeries | undefined
): string | undefined {
  const shortTitle = templateChartSeries?.shortTitle;
  return shortTitle && shortTitle.length > 0 ? shortTitle : undefined;
}
